/**
 * A category's chip (TMMAPP-0037): the category's data colour from `categoricalFor(id)` — the
 * `soft` wash behind `text` (guaranteed 4.5:1) and a leading `line` dot. The dot is decorative
 * (`aria-hidden`); the name is always the label, so the colour never carries meaning alone.
 */
import { Box, Chip, useTheme } from '@mui/material';
import { categoricalFor } from '@/theme/categorical';
import { resolveTokens } from '@/theme/theme';

export function CategoryChip({ id, name }: { id: number; name: string }) {
  const tokens = resolveTokens(useTheme());
  const colour = categoricalFor(id, tokens);
  return (
    <Chip
      size="small"
      label={name}
      data-category-id={id}
      icon={
        <Box
          component="span"
          aria-hidden
          data-testid="category-dot"
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            flexShrink: 0,
            bgcolor: colour.line,
          }}
        />
      }
      sx={{
        maxWidth: '100%',
        bgcolor: colour.soft,
        color: tokens.text,
      }}
    />
  );
}
